export const RESUMIDO_FOLDER_NAMES = {
  generico: 'Genérico',
  'mano-a-mano': 'Mano a Mano'
} as const;
